import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {TARMAC} from '../../../style/colors';
import glamorous from 'glamorous';
import {formatCount} from '../../../utils/format';
import {PHONE} from '../../../style/breakpoints';
import StatsCard from '../stats/new';
import {MOBILE_PADDING} from '../card';

const DESKTOP_MARGIN = 45;
const MOBILE_MARGIN = 25;

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  [PHONE]: {
    padding: MOBILE_PADDING,
    paddingLeft: 5,
    paddingRight: 0,
    height: '100%',
    width: 186,
    marginLeft: -10
  },
  ' > div > div': {
    marginLeft: DESKTOP_MARGIN,
    [PHONE]: {
      marginLeft: MOBILE_MARGIN
    }
  }
});

const Placeholder = glamorous.div({
  ...BASE_TEXT,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontsize: 14,
  color: TARMAC,
  fontStyle: 'italic',
  textAlign: 'center'
});

const SourceStatsNew = ({
  // dependentReposCount = 0,
  dependentPackagesCount = 0,
  // membersCount = 0,
  placeholder = 'No Stats found'
}) => {
  let items = [];
  // if (dependentReposCount >= 0) {
  //   items.push({
  //     stat: formatCount(dependentReposCount),
  //     label: 'Dependent Repos Counts'
  //   });
  // }
  // if (membersCount >= 0) {
  //   items.push({stat: formatCount(membersCount), label: 'Contributor Count'});
  // }
  if (dependentPackagesCount >= 0) {
    items.push({
      stat: formatCount(dependentPackagesCount),
      label: 'Dependent Packages Counts'
    });
  }
  return (
    <Container>
      {items.length > 0 ? <StatsCard items={items} /> : <Placeholder>{placeholder}</Placeholder>}
    </Container>
  );
};

SourceStatsNew.propTypes = {
  // dependentReposCount: PropTypes.number,
  dependentPackagesCount: PropTypes.number,
  // membersCount: PropTypes.number,
  placeholder: PropTypes.string
};

export default SourceStatsNew;
